// src/features/engine/tasks/osrboi/components/OSRBOIForm.js

import { useState, useEffect } from "react";
import axios from "axios";
import { useProgramEngine } from "../../../context/ProgramEngineContext";
import VASRatingInput from "../../../../../components/form-items/VASRatingInput";
import OSRBSOIOverallImpression from "./OSRBSOIOverallImpression";
import { useOptionalTaskRuntime } from "../../../context/TaskRuntimeContext";
import useOSRBOITranslator from "../hooks/useOSRBOITranslator";
import AVIcon from "../../../../../components/icons/AllVoicedIcons";
import CitationsPanel from "../../../../../components/citations/CitationsPanel";

function OSRBOIForm({ onSubmit }) {

  const t = useOSRBOITranslator();
  const [voiceCollection, setVoiceCollection] = useState(null);
  const programEngine = useProgramEngine() || {};
  const runtime = useOptionalTaskRuntime();
  const apiUrl =
    runtime?.apiUrl ||
    programEngine.apiUrl ||
    process.env.REACT_APP_API_URL ||
    "http://localhost:5001/api";

  // ------------------------------------------------------------
  // LOAD VOICE COLLECTION (for citations panel only)
  // ------------------------------------------------------------

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        const res = await axios.get(
          `${apiUrl}/voice-collections/6821a9acf459819632e09ed0`
        );
        setVoiceCollection(res.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCollection();
  }, [apiUrl]);

  const [overallSeverity, setOverallSeverity] = useState(null);
  const [roughness, setRoughness] = useState(null);
  const [breathiness, setBreathiness] = useState(null);
  const [overallImpressionComment, setOverallImpressionComment] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      overallSeverity,
      roughness,
      breathiness,
      overallImpressionComment
    });
  };

  const isFormValid =
    overallSeverity !== null &&
    roughness !== null &&
    breathiness !== null;

  return (
    <form className="app-module" onSubmit={handleSubmit}>

      {/* Scale labels */}
      <div className="capevr-scale-container">
        <span className="capevr-scale-label capevr-scale-left">
          {t("normal")}
        </span>
        <span className="capevr-scale-label capevr-scale-right">
          {t("extreme")}
        </span>
      </div>

      <br />

      <VASRatingInput
        label={t("overall_severity")}
        VASValue={overallSeverity}
        setVASValue={setOverallSeverity}
        index={0}
      />

      <VASRatingInput
        label={t("roughness")}
        VASValue={roughness}
        setVASValue={setRoughness}
        index={1}
      />

      <VASRatingInput
        label={t("breathiness")}
        VASValue={breathiness}
        setVASValue={setBreathiness}
        index={2}
      />

      <br />

      <OSRBSOIOverallImpression
        overallImpressionComment={overallImpressionComment}
        setOverallImpressionComment={setOverallImpressionComment}
      />

      {!isFormValid && (
        <div className="warning-message">
          <AVIcon icon="alert" size={16} color="#209385" />
          <span>
            {t("please_complete_all_scales")}
          </span>
        </div>
      )}

      <div style={{ textAlign: "center", marginTop: "1em" }}>
        <button
          type="submit"
          className="app-btn app-btn-primary"
          disabled={!isFormValid}
        >
          {t("view_feedback")}
        </button>
      </div>

      {/* Citations */}
      {voiceCollection && (
        <CitationsPanel voiceCollection={voiceCollection} />
      )}

    </form>
  );
}

export default OSRBOIForm;
